var stringLiteralsArray = function stringLiteralsArray() {
  var tuple = function tuple() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return args;
  };

  return tuple.apply(void 0, arguments);
};

export default stringLiteralsArray;
//# sourceMappingURL=stringLiteralsArray.js.map
